import React from 'react';
import { map } from 'lodash';
import { useFieldValidation } from '../../hooks/validation-field';
import HelperSection from './HelperSection';
import { FieldContainer, Label } from '../field';
import { CustomField, RadioButtonComponent, OptionLabel, CustomInput, Checkmark } from './mixins';
const RadioButton = ({ name, id, value, options, onChange, onFocus, onBlur, disabled, rules, errors, fieldOptions, }) => {
    const { fieldStates, classes, setValue, setActive } = useFieldValidation(rules, errors, name, disabled);
    const fieldLabel = !!fieldOptions && fieldOptions.label;
    const helperSection = (fieldOptions && fieldOptions.helperText) || errors;
    const handleOnChange = (event, callback) => {
        const target = event.target.value;
        setValue(target);
        callback && callback(event);
    };
    const handleOnBlur = (event, callback) => {
        setActive(false);
        callback && callback(event);
    };
    const handleOnFocus = (event, callback) => {
        setActive(true);
        callback && callback(event);
    };
    return (React.createElement(FieldContainer, null,
        fieldLabel && React.createElement(Label, { htmlFor: id || `radiobutton-${name}` }, fieldLabel),
        React.createElement(CustomField, Object.assign({}, fieldOptions, { states: Object.assign({}, fieldStates), className: classes }), map(options, option => {
            const fieldId = `radiobutton-${name}-${option.id}`;
            const size = !!fieldOptions && { size: fieldOptions.size };
            const checkValue = value ? value === option.id : undefined;
            return (React.createElement(RadioButtonComponent, null,
                React.createElement(CustomInput, { id: fieldId, name: name, type: "radio", value: option.id, disabled: disabled, onChange: event => handleOnChange(event, onChange), onFocus: event => handleOnFocus(event, onFocus), onBlur: event => handleOnBlur(event, onBlur), fieldOptions: size, checked: checkValue, ref: rules }),
                React.createElement(Checkmark, { fieldOptions: size }),
                React.createElement(OptionLabel, { for: fieldId, fieldOptions: size, disabled: disabled }, option.opcion)));
        })),
        helperSection && React.createElement(HelperSection, { errors: errors, name: name, fieldOptions: fieldOptions })));
};
export default RadioButton;
